import Page from "../Common/Page";
import React from "react";
import { Timeline, Row, Col } from "antd";
import { http } from "../Common/http";
import { AuthContext } from "../Auth/Auth";
import moment from "moment";

interface NoticeData {
  noticeId: string;
  noticeDateTime: string;
  message: string;
}
interface StateType {
  notices: NoticeData[];
}

export class HomePage extends React.Component<any, StateType> {
  static contextType = AuthContext;
  private _page: React.RefObject<Page>;

  constructor(props) {
    super(props);
    this._page = React.createRef<Page>();
    this.state = {
      notices: [],
    };
  }

  async componentDidMount() {
    try {
      this._page.current?.setState({ isPageLoading: true });
      await this.loadData();
      this._page.current?.setState({ isPageLoading: false });
    } catch (error) {
      console.log(error);
      this._page.current?.setState({ isPageLoading: false });
    }
  }

  loadData = async () => {
    const result = await http<NoticeData[]>({
      path: "/Master/notices",
      accessToken: this.context.accessToken,
    });

    if (result.ok && result.body) {
      this.setState({
        notices: result.body,
      });
    }
  };

  render(): React.ReactNode {
    return (
      <Page ref={this._page} title="お知らせ" noCheckAuthority={true}>
        <div className="data_content">
          <Row justify="center" style={{ marginTop: "30px" }}>
            <Col span={20}>
              <Timeline>
                {this.state.notices.map((nitem) => (
                  <Timeline.Item
                    key={nitem.noticeId}
                    style={{ whiteSpace: "pre-wrap" }}
                  >
                    {nitem.message}　 (
                    {moment(nitem.noticeDateTime).format("YYYY/MM/DD HH:mm:ss")}
                    )
                  </Timeline.Item>
                ))}
              </Timeline>
            </Col>
          </Row>
        </div>
      </Page>
    );
  }
}
